<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
  <div class="overflow-auto">     
    <table class="table mb-0">
      <thead>
        <tr>
          <th scope="col" class="align-middle">
            <ThOrder :textHeader="'Nº contrato'" :idHeader="'contractId'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" class="align-middle">
            <ThOrder :textHeader="'Fecha'" :idHeader="'date'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" class="align-middle">
            <ThOrder :textHeader="'Estado'" :idHeader="'status'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" class="align-middle">
            <ThOrder :textHeader="'Tienda'" :idHeader="'storeNumber'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" class="align-middle py-4">Operaciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contract in contracts" v-bind:key="contract.contractId">
          <td class="align-middle py-4">{{ contract.contractId }}</td>
          <td class="align-middle py-4">{{ $dateBackToFront(contract.date, true) }}</td>
          <td class="align-middle py-4">{{ contract.status }}</td>
          <td class="align-middle py-4">{{ contract.storeNumber }}</td>
          <td id="operaciones" class="align-middle py-4">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#" @click="detalle(contract.contractId,'contractDetail')">
                  Información contrato</a>
                <a class="dropdown-item py-3 px-4" href="#" @click="detalleClient(contract.customer.legalIdentifier)">
                  Información cliente</a>
                <a class="dropdown-item py-3 px-4" href="#" @click="detalle(contract.contractId,'documents')">
                  Documentos</a>
                <a class="dropdown-item py-3 px-4" href="#" @click="detalle(contract.contractId,'payPlans')">
                  Ver planes de pago</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="form-group" v-if="numberPages > 1">
          <div class="float-left mr-3 mt-2">
            <select v-model="itemsPerPage" class="form-control" id="itemsPerPage" @change="changeItemsPerPage()">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <label for="itemsPerPage" class="col-form-label mt-2">Clientes por página</label>
        </div>
      </div>
      <div class="col-12 col-md-8" v-if="numberPages > 1">
        <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
      </div>
    </div>
    <ContractDetail :id="'contractDetail'" :modalTitle="'INFORMACIÓN DEL CONTRATO'" :class="'modal-xl'"
      :contractId="contractId">
    </ContractDetail>
    <PayPlans :id="'contractDetail'" :modalTitle="'PLANES DE PAGO'" :class="'modal-lg'" :contractId="contractId">
    </PayPlans>
    <ClientDetail :id="'clientDetail'" :modalTitle="'INFORMACIÓN DEL CLIENTE'" :class="'modal-xl'"
      :clientInfo="clientInfo">
    </ClientDetail>
    <Documents :id="'documents'" :modalTitle="'DOCUMENTOS'" :class="'modal-xl'" :contractId="contractId">
    </Documents>
    <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
      :message="errorMessage" :code="errorCode" />
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import ThOrder from '../../../Shared/ThOrder.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
import ClientDetail from './ClientDetail.vue';
import ContractDetail from './ContractDetail.vue';
import PayPlans from './PayPlans.vue';
import Documents from './Documents.vue';
import axios from 'axios';
import { Modal as ModalBootstrap } from "bootstrap";
import ModalError from '../../../Shared/ModalError.vue'
export default {
  name: 'ContractsList',
  props: [
    'id',
    'modalTitle',
    'class',
    'clientDni'
  ],
  data() {
    return {
      classes: this.class,
      contracts: [],
      currentOrder: '',
      currentOrderBy: '',
      filters: '',
      currentPage: 0,
      numberPages: 0,
      itemsPerPage: 25,
      totalItems: 0,
      from: 0,
      to: 0,
      order: '',
      contractId: '',
      clientInfo: '',
    };
  },
  updated() {
    this.loadContractsData();
  },
  created() {
    this.loadContractsData();
  },
  components: {
    Modal,
    ThOrder,
    Pagination,
    ClientDetail,
    ContractDetail,
    PayPlans,
    Documents,
    ModalError
  },
  methods: {
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}&`;
    },
    loadContractsData() {
      this.filterPagination();

      this.filters = `${this.filters}customer.legalIdentifier=${this.clientDni}&`;

      const vm = this
      let apiUrl = '';
      if (this.$store.state.roles.Backoffice_member_empresas) {
        apiUrl = '/business/contract/search?'
      } else {
        apiUrl = '/contract/search?';
      }
      axios.get(apiUrl + `${this.filters}`)
        .then((response) => {
          vm.contracts = response.data.contracts;
          vm.totalItems = response.data.pagination.totalElements;
          vm.filters = '';
          vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
            ? vm.totalItems / vm.itemsPerPage
            : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

          vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
          vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
            ? vm.totalItems
            : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;
        });
    },
    selectOrder(value) {
      if (this.currentOrderBy != value.orderBy) {
        this.currentOrder = '';
      }
      this.currentOrderBy = value.orderBy;
      this.currentOrder = value.order;
      this.$emit('selectOrder', { order: this.currentOrder, orderBy: this.currentOrderBy });
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadclients();
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadProducts();
    },
    detalle: function (idContract, identifier) {
      this.contractId = idContract;
      var myModal = new ModalBootstrap(document.getElementById(identifier))
      myModal.show()
    },
    detalleClient: function (dni) {
      axios.get(`/customer/${dni}`)
        .then((response) => {
          this.clientInfo = response.data;
          var myModal = new ModalBootstrap(document.getElementById('clientDetail'))
          myModal.show()
        }).catch((error) => {
          this.errorCode = error.response.data.code
          this.errorMessage = error.response.data.message
          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show()
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
